import Banner from '@structure/Resources/Banner';
import ShowcaseConfig from '@structure/Configuration/ShowcaseConfig';
import * as path from 'path';
import { SerializedResource, PathParts } from '@/types';

export default class Showcase {
  constructor(
    protected configuration: ShowcaseConfig,
    protected banner: Banner
  ) {
    //
  }

  public wallpaper(): string {
    const { directory, basename } = this.config().get<PathParts>('wallpaper');

    return path.join(directory, basename);
  }

  public static(): Banner | null {
    if (!this.config().has('static')) {
      return null;
    }

    const resource: SerializedResource = {
      ...this.config().get<PathParts>('static'),
      type: 'banner',
      dimensions: {
        width: 300,
        height: 250,
        isRetina: false,
      },
    };

    return new Banner(resource, this.banner.directory());
  }

  public config(): ShowcaseConfig {
    return this.configuration;
  }

  public resource(): Banner {
    return this.banner;
  }
}
